export default function convertTimeto24hr(inputTime) {
  if (inputTime == null) {
    return 'inputTime is null'
  }

  // remove any spaces and convert to lowercase
  const normalizedTime = inputTime.replace(/\s/g, '').toLowerCase()

  // Extract hours, minutes, and am/pm indicator
  const match = normalizedTime.match(/(\d{1,2}):(\d{2})(am|pm)/)
  if (!match) {
    return 'Invalid time format'
  }

  const [, hourStr, minuteStr, period] = match

  // Convert hours to number
  let hours = parseInt(hourStr, 10)

  if (hours === 12) {
    hours = period === 'am' ? 0 : 12
  } else if (period === 'pm') {
    hours += 12
  }

  // Ensure hours and minutes are two digits
  const formattedHours = hours.toString().padStart(2, '0')
  const formattedMinutes = minuteStr.padStart(2, '0')

  return `${formattedHours}:${formattedMinutes}`
}
